import { Button, Modal } from '@warp-ds/react';
import { useState } from 'react';

interface ShareAdProps {
    adId: number;
    title?: string;
    open: boolean;
    toggleModal: () => void;
}

export const shareAdTexts = {
    buttons: {
        shareAd: 'Del',
        copyLink: 'Kopier lenke',
        copyDone: 'Kopiert',
        shareOnFacebook: 'Del på facebook',
        shareOnX: 'Del på X',
        shareByMail: 'Del på e-post',
    },
    modal: {
        title: 'Del lenke',
    },
};

export const ShareAd = ({ adId, title, open, toggleModal }: ShareAdProps) => {
    const [copy, setCopy] = useState(false);
    const shareLink = `https://www.finn.no/${adId}`;

    const uParamFacebook = encodeURIComponent(`${shareLink}?taid=Share_ad_facebook`);

    const urlParamX = encodeURIComponent(`${shareLink}?taid=Share_ad_twitter`);
    const textParamX = encodeURIComponent(title ?? 'Sjekk denne annonsen på Finn.no!');

    const urlBuilder = {
        emailUrl:
            'mailto:?subject=Tips: ' +
            encodeURIComponent(title ?? '') +
            '&body=Jeg fant dette på finn.no: ' +
            encodeURIComponent(shareLink),
        facebookUrl: `https://www.facebook.com/sharer/sharer.php?u=${uParamFacebook}`,
        xUrl: `https://twitter.com/intent/tweet?via=FINN_no&related=Finn_no&url=${urlParamX}&text=${textParamX}`,
    };

    const copyLink = () => {
        const shareLinkTextFieldId = document.getElementById('share-link-text') as HTMLInputElement | null;
        shareLinkTextFieldId?.select();
        // TODO: It will not work for http
        navigator?.clipboard?.writeText(shareLinkTextFieldId?.value || '');
        if (!copy) {
            setCopy(true);
        }
    };

    return (
        <Modal open={open} right onDismiss={toggleModal} title={shareAdTexts.modal.title}>
            <div data-testid="share-ad-modal">
                <input
                    onClick={(event) => (event.target as HTMLInputElement).select()}
                    className="w-full"
                    type="text"
                    data-testid="share-link-text"
                    id="share-link-text"
                    value={shareLink}
                    readOnly
                />
                <div className="flex justify-between mt-16">
                    <div className="flex">
                        <Button
                            quiet
                            utility
                            href={urlBuilder.emailUrl}
                            title={shareAdTexts.buttons.shareByMail}
                            aria-label={shareAdTexts.buttons.shareByMail}
                            data-testid="email-share-link"
                            className="p-12"
                            rel="nofollow">
                            <w-icon name="Mail" size="medium" />
                        </Button>
                        <Button
                            quiet
                            utility
                            href={urlBuilder.facebookUrl}
                            title={shareAdTexts.buttons.shareOnFacebook}
                            aria-label={shareAdTexts.buttons.shareOnFacebook}
                            data-testid="facebook-share-link"
                            className="p-12"
                            rel="nofollow">
                            <w-icon name="Facebook" size="medium" />
                        </Button>
                        <Button
                            quiet
                            utility
                            href={urlBuilder.xUrl}
                            title={shareAdTexts.buttons.shareOnX}
                            aria-label={shareAdTexts.buttons.shareOnX}
                            data-testid="x-share-link"
                            className="p-12"
                            rel="nofollow">
                            <w-icon name="X" size="medium" />
                        </Button>
                    </div>
                    <Button
                        primary
                        className="flex items-center"
                        onClick={copyLink}
                        data-testid="copy-link-button"
                        aria-label={copy ? shareAdTexts.buttons.copyDone : shareAdTexts.buttons.copyLink}>
                        {copy ? (
                            <>
                                <span className="mr-8">{shareAdTexts.buttons.copyDone}</span>
                                <w-icon name="Check" size="small" />
                            </>
                        ) : (
                            shareAdTexts.buttons.copyLink
                        )}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
